var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.queryForm, "label-width": "90px" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.spanCol } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "逻辑仓编码" } },
                    [
                      _c("BjInput", {
                        attrs: { placeholder: "逻辑仓编码", clearable: "" },
                        model: {
                          value: _vm.queryForm.stockWarehouseCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "stockWarehouseCode", $$v)
                          },
                          expression: "queryForm.stockWarehouseCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.spanCol } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "逻辑仓名称" } },
                    [
                      _c("BjInput", {
                        attrs: { placeholder: "逻辑仓名称", clearable: "" },
                        model: {
                          value: _vm.queryForm.stockWarehouseName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "stockWarehouseName", $$v)
                          },
                          expression: "queryForm.stockWarehouseName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                  attrs: { span: 24 - _vm.spanCol * 2 },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "m20",
                      attrs: { type: "cyan", icon: "el-icon-search" },
                      on: { click: _vm.onSearch },
                    },
                    [_vm._v(_vm._s(_vm.$t("queryText")))]
                  ),
                  _vm.showResetBtn
                    ? _c("el-button", { on: { click: _vm.resetQueryForm } }, [
                        _vm._v(_vm._s(_vm.$t("resetText"))),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.data,
            border: "",
            stripe: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-style": _vm.rowStyleFun,
            height: _vm.height,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "选择", width: "55", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-radio",
                      {
                        attrs: {
                          label: scope.row.stockNo,
                          disabled: !_vm.checkSelectable(scope.row),
                        },
                        nativeOn: {
                          change: function ($event) {
                            return _vm.getCurrentRow(scope.row)
                          },
                        },
                        model: {
                          value: _vm.radio,
                          callback: function ($$v) {
                            _vm.radio = $$v
                          },
                          expression: "radio",
                        },
                      },
                      [_vm._v(" " + _vm._s("") + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { type: "expand", label: "查看可用库存", width: "160px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px" } },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: props.row.stockList,
                              border: "",
                              "header-cell-style": _vm.$rowStyle.LIGHT_BLUE,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "skuCode",
                                label: "SKU编码",
                                align: "center",
                                width: "160px",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "skuName",
                                label: "SKU名称",
                                align: "center",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "number",
                                label: "可用数量",
                                align: "center",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "stockNo", label: "逻辑仓编码", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "stockName", label: "逻辑仓名称", align: "center" },
          }),
        ],
        1
      ),
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("BjInput", {
                    attrs: { readonly: "", placeholder: "请选择逻辑仓" },
                    model: {
                      value: _vm.selectedData.stockName,
                      callback: function ($$v) {
                        _vm.$set(_vm.selectedData, "stockName", $$v)
                      },
                      expression: "selectedData.stockName",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(" 指定发货仓 ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }